/* eslint-disable no-unused-vars */
import Vue from "vue";
// eslint-disable-next-line no-unused-vars
import router from "../../router";
import Supplier from "./Supplier";

const state = {
	status: "",
	token: localStorage.getItem("customer_token") || "",
	customer: localStorage.getItem("customer") || "",
	firstSurety:localStorage.getItem("firstSurety") || "",
	secondSurety:localStorage.getItem("secondSurety")|| ""
	// JSON.parse(localStorage.getItem("customer").toString()) || "",
};

const getters = {
	isLoggedIn (state)
	{
		if(state.token)
		{
			return true
		}
		return false
	},
	getCustomer(state) {
		
		return state.customer;
	},
	getMobileNumber(state) {
		return state.customer.mobile_number;
	},
	getPassword(state) {
		return state.customer.password;
	},
	getMelliCode(state) {
		return state.customer.melli_code;
	},
	getFirstName(state) {
		
		try
		{
			
			return JSON.parse(state.customer).first_name;
		}
		catch
		{
			return state.customer.first_name
		}
		
		
	},
	getLastName(state) {
		try
		{
			return JSON.parse(state.customer).last_name;
		}
		catch
		{
			return state.customer.last_name
		}
	},
	getFirstSurety(state)
	{
		return state.firstSurety;
	},
	getSecondSurety(state)
	{
		return state.secondSurety;
	}
	
	
};

const mutations = {
	setCustomerToken(state, token) {
		
		state.token = token;
		
	},
	
	setFirstSurety(state,firstSurety)
	{
		state.firstSurety = firstSurety
	},
	setSecondSurety(state,firstSurety)
	{
		state.secondSurety = firstSurety
	},
	
	setCustomer(state, customer) {
		console.log("----------------------------------------------before change :" + state.customer + JSON.stringify(state.customer))
		state.customer = customer;
		console.log("----------------------------------------------after change :" + state.customer + JSON.stringify(state.customer))
		
	},
	setMobileNumber(state, mobile_number) {
		state.customer.mobile_number = mobile_number;
	},
	logout(state) {
		state.customer=""
		state.token = ""
	},
};

const actions = {
	getContracts(context) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getOtp(context, form) {
		// context.dispatch("logOut");
		return new Promise((resolve, reject) => {
			console.log("befor");
			context.commit("setCustomer", form);
			localStorage.setItem("customer", JSON.stringify(form));
			console.log("after");
			Vue.http
				.post("api/registration/otp/", form)
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getContractDetail(context, id) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/" + id, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	
	getCustomerInstalments(context, contract_id) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/" + contract_id + "/instalments", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getForgotPassOtp(context,melli_code)
	{
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/registration/reset_password", {melli_code:melli_code} 
					
				)
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	checkForgotPassOtp(context,data)
	{
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/registration/reset_password", data
					
				)
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getCustomerPayments(context, contract_id) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/" + contract_id + "/payments", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	checkOtp(context, otp) {
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/registration/otp/", otp)
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	
	resentOtp(context) {
		return new Promise((resolve, reject) => {
			let url =
				"api/registration/otp/" +
				"?mobile_number=" +
				localStorage.getItem("mobile_number");
			Vue.http
				.get(url)
				.then((response) => {
					localStorage.setItem("otp_code", "ok");
					resolve(response);
				})
				.catch((err) => {
					context.commit("auth_error", err);
					reject(err);
				});
		});
	},
	creatCustomer(context, customer_data) {
		let token = localStorage.getItem("customer_token")
		if(token && localStorage.getItem("SupplierCustomerId"))
		{
			return new Promise((resolve, reject) => {
				Vue.http
					.post("api/registration/customer/", customer_data,{headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token")
						
					}})
					.then((resp) => {
						localStorage.setItem("customer", JSON.stringify(resp.body));
						context.commit("setCustomer", resp.body);
						resolve(resp);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
		
		else
		{
			return new Promise((resolve, reject) => {
				Vue.http
					.post("api/registration/customer/", customer_data,)
					.then((resp) => {
						localStorage.setItem("customer", JSON.stringify(resp.body));
						//context.commit("setCustomer", resp.body);
						resolve(resp);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
		
	},
	createFirstSurety(context,suretyData)
	{
		
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		if(SupplierCustomerId)
		{
			suretyData.customerID = SupplierCustomerId
		}
		
		if(suretyData.id)
		{
			return new Promise((resolve, reject) => {
				Vue.http
					.put("api/registration/surety/", suretyData,{headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token")
						
					}})
					.then((resp) => {
						localStorage.setItem("firstSurety", resp.body);
						context.commit("setFirstSurety", resp.body);
						resolve(resp);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
		else
		{
				return new Promise((resolve, reject) => {
			Vue.http
				.post("api/registration/surety/", suretyData,{headers: {
					Authorization: "Bearer " + localStorage.getItem("customer_token")
					
				}})
				.then((resp) => {
					localStorage.setItem("firstSurety", resp.body);
					context.commit("setFirstSurety", resp.body);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
		}
	
	},
	updateCustomer(context, customer_data) {
		let path="api/registration/customer/"
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		
		// path="api/registration/customer/?customerID="+SupplierCustomerId
		//customer_data.melli_code = localStorage.getItem("SupplierCustomerMelliCode")
		customer_data.customerID = SupplierCustomerId
			
		
		
		return new Promise((resolve, reject) => {
			Vue.http
				.put(path, customer_data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					localStorage.setItem("customer", JSON.stringify(resp.body));
					context.commit("setCustomer", resp.body);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateSurety(context, data) {
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		if(SupplierCustomerId)
		{
			data.customerID = SupplierCustomerId
		}
		let	path="api/registration/surety/"
		
		
		
		return new Promise((resolve, reject) => {
			Vue.http
				.put(path, data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					// localStorage.setItem("customer", resp.body);
					// context.commit("setCustomer", resp.body);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	createUserDocs(context, docs) {
		let path=""
		
		if(docs.isSurety)
		{
			path="api/document/surety/"
		}
		
		else
		{
			path="api/document/customer/"
		}
		
		return new Promise((resolve, reject) => {
			Vue.http
				.post(path, docs.data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	
	
	getUserDocs(context,surety) {
		let path=""
	
		if(surety.isSurety && surety.isFirstSurety)
		{
			path="api/document/surety?surety_order=0"
		}
		else if(surety.isSurety && !surety.isFirstSurety)
		{
			path="api/document/surety?surety_order=1"
		}
		else
		{
			path="api/document/customer/"
		}
		

		return new Promise((resolve, reject) => {
			Vue.http
				.get(path, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	
	updateUserDocs(context, docs) {
		let path=""
		if(docs.isSurety)
		{
			path="api/document/surety/"
		}
		else
		{
			path="api/document/customer/"
		}
		return new Promise((resolve, reject) => {
			Vue.http
				.put(path, docs.data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	
	
	
	},
	sendMelliCode(context,data)
	{
		let path=""
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		if(SupplierCustomerId)
		{
			path="api/registration/surety/?customerID="+SupplierCustomerId + "&surety_mellicode="+data
		}
		else
		{
			path="api/registration/surety?surety_mellicode="+data
		}
		localStorage.setItem("suretyMelliCode",data)
		return new Promise((resolve, reject) => {
			Vue.http
				.get(path, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					// localStorage.setItem("customer", resp.body);
					// context.commit("setCustomer", resp.body);
					resolve(resp);
				})
				.catch((err) => {
					
					reject(err);
				});
		});
	},
	login(context, loginData) {
		return new Promise((resolve, reject) => {
			context.dispatch("logOut");
			Vue.http
				.post("login/", loginData)
				.then((response) => {
					context.commit("auth_request");
					const token = response.body.access;

					localStorage.setItem("customer_token", token);
					localStorage.removeItem("SupplierCustomerId")
					localStorage.removeItem("SupplierCustomerMelliCode")
					state.token = token
					Vue.http.headers.common["Authorization"] = "Bearer " + token;

					resolve(response);
				})
				.catch((err) => {
					localStorage.removeItem("customer_token");
					reject(err);
				});
		});
	},
	logOut(context) {
		return new Promise((resolve) => {
			context.commit("logout");
		
			localStorage.removeItem("first_name");
			localStorage.removeItem("last_name");
			localStorage.removeItem("customer");
			
			localStorage.removeItem("customer_token");
			if(localStorage.getItem("supplierCustomerId"))
			{
				localStorage.removeItem("supplierCustomerId")
			}
			if(localStorage.getItem("supplier_name"))
			{
				localStorage.removeItem("supplier_name")
			}
			
			localStorage.removeItem("phone_number");
			
			delete Vue.http.headers.common["Authorization"];

			resolve(status.HTTP_200_OK);
		});
	},
	getForgotPassMobile(context, melliCode) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/registration/reset_password?melli_code="+melliCode)
				.then((response) => {
					localStorage.setItem("mobile_number", response.body.mobile_number);
					resolve(response);
				})
				.catch((err) => {
					console.log(err);
					// state.commit('auth_error', err)
					reject(err);
				});
		});
	},
	// getForgotPassOtp(context, form) {
	// 	return new Promise((resolve, reject) => {
	// 		Vue.http
	// 			.post("api/registration/reset_password", form)
	// 			.then((response) => {
					
	// 				resolve(response);
	// 			})
	// 			.catch((err) => {
	// 				console.log(err);
	// 				// state.commit('auth_error', err)
	// 				reject(err);
	// 			});
	// 	});
	// },
	ForgotPassChange(context, form) {
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/registration/reset_password", form)
				.then((response) => {
					
					resolve(response);
				})
				.catch((err) => {
					console.log(err);
					// state.commit('auth_error', err)
					reject(err);
				});
		});
	},
	getCustomer(context) {
		let path=""
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		if(SupplierCustomerId)
		{
			path="api/registration/customer/?customerID="+SupplierCustomerId
		}
		else
		{
			path="api/registration/customer/"
		}
		return new Promise((resolve, reject) => {
			Vue.http
				.get(path, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					localStorage.setItem("first_name", response.body.first_name);
					localStorage.setItem("last_name", response.body.last_name);
					localStorage.setItem("customer", JSON.stringify(response.body));
					context.commit("setCustomer", response.body);
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getFirstSurety(context) {
		let path=""
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		if(SupplierCustomerId)
		{
			path="api/registration/surety?customerID="+SupplierCustomerId + "&surety_order=0"
		}
		else
		{
			path="api/registration/surety?surety_order=0"
		}
		return new Promise((resolve, reject) => {
			Vue.http
				.get(path, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					localStorage.setItem("first_name", response.body.first_name);
					localStorage.setItem("last_name", response.body.last_name);
					localStorage.setItem("firstSurety", JSON.stringify(response.body));
					context.commit("setFirstSurety", response.body);
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getSecondSurety(context) {
		let path=""
		let SupplierCustomerId = localStorage.getItem("SupplierCustomerId")
		if(SupplierCustomerId)
		{
			path="api/registration/surety?customerID="+SupplierCustomerId + "&surety_order=1"
		}
		else
		{
			path="api/registration/surety?surety_order=1"
		}
		return new Promise((resolve, reject) => {
			Vue.http
				.get(path, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					localStorage.setItem("first_name", response.body.first_name);
					localStorage.setItem("last_name", response.body.last_name);
					localStorage.setItem("secondSurety", JSON.stringify(response.body));
					context.commit("setSecondSurety", response.body);
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	customerClac(context, calc_data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/registration/calculator", calc_data, 
				
				)
				.then((resp) => {
					// localStorage.setItem("level", resp.body);
					// context.commit("setCustomer", resp.body);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};

export default {
	state,
	getters,
	mutations,
	actions,
};
